import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_SERVICE_WAREHOUSES = "fetchServiceWarehouses";
export const FETCH_SERVICE_WAREHOUSE = "fetchServiceWarehouse";
export const SAVE_SERVICE_WAREHOUSE = "saveServiceWarehouse";
export const UPDATE_SERVICE_WAREHOUSE = "updateServiceWarehouse";
export const DELETE_SERVICE_WAREHOUSE = "deleteServiceWarehouse";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingServiceWarehouse";

const state = {
  errors: [],
  isLoadingServiceWarehouse: false
};

const getters = {
  isLoadingServiceWarehouse() {
    return state.isLoadingServiceWarehouse;
  }
};

const actions = {
  [FETCH_SERVICE_WAREHOUSES](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-warehouses" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_SERVICE_WAREHOUSE](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-warehouses", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_SERVICE_WAREHOUSE](context, payload) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("service-warehouses", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_SERVICE_WAREHOUSE](context, params) {
    context.commit(SET_LOADING, true);

    const id = params.id;

    return new Promise((resolve, reject) => {
      ApiService.update("service-warehouses", id, params.payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_SERVICE_WAREHOUSE](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("service-warehouses", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingServiceWarehouse = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingServiceWarehouse = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
